import * as Yup from "yup";

const Number_Regex = /^\d+$/;
const MobileNumber_Regex = /^[\d+]+$/;
const Url_Regex =
  /(^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w[a-zA-Z-_%@?]+)*([^\w[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$|^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$)/;
const PAN_Regex = /[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/;
const GST_Regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
const GST_Regex2 = /^[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

const OnlyAlphabets = /^[^-\s0-9~@#$^*()_+-=/[\]{}|\\,.?: -][a-zA-Z\s]*$/;
const TelNos_Regex =
  /^\+?[1-9]\d{0,3}[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
const latitude_Regex = /^([+-]?([1-8]?\d(\.\d+)?|90(\.0+)?))$/;
const longitude_Regex = /^([+-]?((1[0-7]\d|[1-9]?\d)(\.\d+)?|180(\.0+)?))$/;

const AadharRegex = /^\d{12}$/;
const tanRegex = /^[A-Z]{4}[0-9]{5}[A-Z]$/;
const vatNoRegex = /^[A-Z0-9]{8,15}$/;
const bankAccNoRegex = /^[0-9]{9,18}$/;
const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
const micrRegex = /^[0-9]{9}$/;

const pinCodeValidation = Yup.string()
  .max(6, "Invalid pin")
  .matches(Number_Regex, "Invalid pin");
const mobileValidation = Yup.string()
  .min(10, "Invalid Mobile")
  .matches(MobileNumber_Regex);
const emailValidation = Yup.string().email("Invalid email");
const telephoneValidation = Yup.string().matches(
  TelNos_Regex,
  "Invalid Telephone Number"
);
const urlValidation = Yup.string().matches(Url_Regex, "Invalid Website Url");
const panNoValidation = Yup.string().matches(PAN_Regex, "Invalid PAN No");
const gstValidation = Yup.string().matches(GST_Regex, "Invalid GST No");
const tanNoValidation = Yup.string().matches(tanRegex, "Invalid Tan");
const latitudeValidation = Yup.string().matches(
  latitude_Regex,
  "Invalid Latitude"
);
const longitudeValidation = Yup.string().matches(
  longitude_Regex,
  "Invalid Longitude"
);
const aadharValidation = Yup.string()
  .matches(AadharRegex, "Invalid Aadhar No")
  .max(12, "Invalid Aadhar");
const vatNoValidation = Yup.string().matches(vatNoRegex, "Invalid Vat No");
const bankAccNoValidation = Yup.string().matches(
  bankAccNoRegex,
  "Invalid Bank Acc No"
);
const ifscValidation = Yup.string().matches(ifscRegex, "Invalid Ifsc");
const micrValidation = Yup.string().matches(micrRegex, "Invalid MICR");

export const customerValidation = Yup.object({
  name: Yup.string()
    .max(120, "customer name is long")
    .required("Customer name is required"),
  pin: pinCodeValidation,
  email: emailValidation.required("Email is required"),
  mobile: mobileValidation.required("Mobile is required"),
  url: urlValidation,
  panNo: panNoValidation,
  gstNo: Yup.string().matches(GST_Regex2, "Invalid GST No"),
});

export const userValidation = Yup.object({
  name: Yup.string().required("Name is required").matches(OnlyAlphabets),
  pin: pinCodeValidation,
  mobile: mobileValidation,
});

export const itemDetaildsValidation = Yup.object({
  alias: Yup.string().matches(OnlyAlphabets),
  prodLatitude: latitudeValidation,
  prodLongitude: longitudeValidation,
});

export const junctoinLabel = Yup.object({
  name: Yup.string().required("Name is required"),
  pin: pinCodeValidation,
  mobile: mobileValidation,
  email: emailValidation,
  latitude: latitudeValidation,
  longitude: longitudeValidation,
});
export const companyValidation = Yup.object({
  // Company Details
  name: Yup.string()
    .max(120, "company name is long")
    .required("Company Name is required"),
  address: Yup.string().required("Address is required"),
  pin: pinCodeValidation,
  telephone: telephoneValidation,
  email: emailValidation,
  mobileNo: mobileValidation,
  latitude: latitudeValidation,
  longitude: longitudeValidation,

  // Contact Details
  contactPerson: Yup.string()
    .required("Contact Person's Name is required")
    .matches(
      OnlyAlphabets,
      "Contact Person's Name must contain only alphabets"
    ),
  contactPersonDesign: Yup.string().required("Designation is required"),
  contactPersonEmail: emailValidation,
  contactPersonMobile: mobileValidation,
  // url: Yup.string().url("Invalid URL").required("Company URL is required"),

  // Statuary Details
  enableGst: Yup.boolean(),
  gstNo: Yup.string().matches(GST_Regex2, "Invalid GST No"),
  tanNo: tanNoValidation,
  panNo: panNoValidation,
});

export const subsidiarySiteValidation = Yup.object({
  // Company Details
  name: Yup.string()
    .max(100, "Company name is long")
    .required("Company Name is required")
    .matches(OnlyAlphabets, "Company Name must contain only alphabets"),
  address: Yup.string(),
  pin: pinCodeValidation,
  telephone: telephoneValidation,
  email: emailValidation,
  mobile: Yup.string().min(10, "Invalid Mobile").matches(MobileNumber_Regex),
  latitude: latitudeValidation,
  longitude: longitudeValidation,

  // Contact Details
  contactPerson: Yup.string().matches(
    OnlyAlphabets,
    "Contact Person's Name must contain only alphabets"
  ),
  contactPersonDesign: Yup.string(),
  contactPersonEmail: emailValidation,
  contactPersonMobile: Yup.string()
    .min(10, "Invalid Mobile")
    .matches(MobileNumber_Regex),
});

export const categoryValidation = Yup.object({
  // Company Details
  groupName: Yup.string().required("Category Name is required"),
});

export const mouValidation = Yup.object({
  // Company Details
  decimalNos: Yup.string(),
});

export const itemValidation = Yup.object({
  // Company Details
  desc: Yup.string().required("Item Description is required"),
});

export const supplierDetailsValidation = Yup.object({
  // Details
  supplier_name: Yup.string().required("Supplier Name is required"),
  address: Yup.string(),
  pin: pinCodeValidation,
  phone: mobileValidation.required("Mobile no is required"),
  email: emailValidation,
  // Contact Fields
  contactPerson: Yup.string()
    .required("Contact Person's Name is required")
    .matches(
      OnlyAlphabets,
      "Contact Person's Name must contain only alphabets"
    ),
  contactPersonPin: pinCodeValidation,
  contactPersonMobile: mobileValidation,
  contactPersonEmail: emailValidation,
  contactPersonAadhar: aadharValidation,
});

export const supplierRequiredDetailsValidation = Yup.object({
  // Details
  gstNo: gstValidation,
  tanNo: tanNoValidation,
  panNo: panNoValidation,
  vatNo: vatNoValidation,
  bankAcNo: bankAccNoValidation,
  bankIfsc: ifscValidation,
  bankMicr: micrValidation,
  alterContactPersonMobile: mobileValidation,
  alterContactPersonEmail: emailValidation,
  alterContactPersonAadhar: aadharValidation,
});

export const projectDetailsValidation = Yup.object({
  name: Yup.string().required("Name is required"),
  workOrderNum: Yup.string().required("Work Order Number is required"),
});

export const multiLocationValidation = Yup.object({
  // Details
  address: Yup.string().required("Address is required"),
  pin: pinCodeValidation,
  gstNo: gstValidation,
  tanNo: tanNoValidation,
  panNo: panNoValidation,
  vatNo: vatNoValidation,
  contactPersonPin: pinCodeValidation,
  contactPersonEmail: emailValidation,
  contactPersonMobile: mobileValidation,
  contactPersonAadhar: aadharValidation,
});

export const concludeFormValidation = Yup.object({
  // Details
  acceptQty: Yup.string(),
  acceptRate: Yup.string(),
  acceptValue: Yup.string(),
  acceptRemarks: Yup.string(),
  udfItemDesc: Yup.string().required("Description sent on RFQ is required"),
});

export const PredefineDataInputValidate = Yup.object({
  type: Yup.string(),
  indexno: Yup.string(),
  value1: Yup.string(),
  value2: Yup.string(),
  value3: Yup.string(),
  value4: Yup.string(),
});

export const materialItemValidation = Yup.object({
  udfItemDesc: Yup.string(),
});

export const rfqPoAddItem = Yup.object({
  udfItemDesc: Yup.string(),
});

export const rfqQuotationSchema = Yup.object({
  itemDescChanged: Yup.string(),
});

export const negotiationDetailsValidation = Yup.object({
  negoStatus: Yup.boolean().required("Place order is required"),
  negoRate: Yup.number().required("Verbal final rateis required"),
  negoQty: Yup.number().required("Quantity is required"),
  negoOther: Yup.number().required("Others is required"),
  negoTaxable: Yup.number().required("Taxable is required"),
  negoTax: Yup.number().required("Taxes is required"),
  negoDelvChrg: Yup.number().required("Delivery charges is required"),
  negoInstChrg: Yup.number().required("Instant charges is required"),
  negoValue: Yup.number().required("Verbal Final Amount is required"),
});

export const emailConfigValidation = Yup.object({
  from: Yup.string().required("form is required"),
  password: Yup.string().required("password is required"),
  smtpHost: Yup.string().required("smtp host is required"),
  smtpPort: Yup.string().required("smtp portis required"),
});

export const quotationItemValidation = Yup.object({
  mrfNo: Yup.string().required("mrf number is required"),
});

export const raiseTicketValidation = Yup.object({
  remarks: Yup.string().required("Remarks is required"),
});

export const raiseTicketValidationOptional = Yup.object({
  remarks: Yup.string(),
});
export const groupingValidation = Yup.object({
  // Company Details
  groupName: Yup.string().required("Group Name is required"),
});

export const meetingValidation = Yup.object({
  meetingDate: Yup.string().required("Remarks is required"),
});
